import sticky from "app/modules/_sticky"
import cssVars from "css-vars-ponyfill"
import ReactRenderer from 'app/modules/_react-renderer'
import Configurator from './React/Configurator'
import ConfiguratorWidget from './React/ConfiguratorWidget'

cssVars()
sticky()

ReactRenderer.registerComponent('Configurator', Configurator)
ReactRenderer.registerComponent('ConfiguratorWidget', ConfiguratorWidget)
ReactRenderer.render()
